<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title v-if="legis_exists">
      <v-row no-gutters>
        <span class="titlecapno text-h5 mr-3">{{capnum}} </span> 
        <span class="text-h2 mb-0"> {{cur_ver ? cur_ver.title : ''}}</span>
      </v-row>
    </template>

    <template v-slot:leftPanel>
      <!--Legis Info Card-->
      <InfoTable
        class="d-print-none"
        :titleText="$t('database.wdg_legis')"
        :tableContent="infoTableContent"
        :contentType="'l_legis'"
      />
    </template>

    <template v-slot:mainPanel>
      <template v-if="legis_exists">
        <div class="d-print-none">
          <!--show all button-->
          <v-card class="pa-0 d-print-none lsidebg" flat >
            <v-card-actions class="pa-0">
              <v-spacer></v-spacer>
              <v-btn
                elevation="0" color="link" text
                class="link lighten-5 px-6" 
                active-class="no-active"
                :to="{name: navToggle.pageName, params: $route.params}"
              >
                <v-icon small color="link" class="mr-4"> {{ navToggle.btnIcon }} </v-icon> 
                {{ navToggle.btnText }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>

          </v-card>

          <!--version and lang toolbar-->
          <v-card flat class="pr-3 py-0 mt-5 mb-2 lsidebg d-print-none">
            <v-card-text class="px-3 py-2">

              <v-row no-gutters>
              <!--change version-->
                <v-col cols="12" sm="7" md="6" class="pa-0 ma-0">
                  <v-select
                    :items="versions"
                    item-text="datestr"
                    item-value="id"
                    v-model="vid"
                    :disabled="overlay"
                    class="shrink"
                    color="link"
                    label="Version History"
                    dense outlined hide-details
                    @change="change_ver($event)"
                  ></v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-btn text color="link" class="ml-2" v-if="lang!='en'" @click="go_trans('en')"> English</v-btn>
                <v-btn text color="link" class="ml-2" v-if="lang!='tc'" @click="go_trans('tc')"> 繁體中文</v-btn>
                <v-btn text color="link" class="ml-2" v-if="lang!='sc'" @click="go_trans('sc')"> 简体中文</v-btn>
              </v-row>

            </v-card-text>
          </v-card>

          <!--alert for past version-->
          <v-alert
            dense text
            type="warning"
            class="mt-0 mb-4 d-print-none"
            icon="mdi-alert-circle-outline"
            v-if="!is_latest"
          >
            <strong>{{$t('database.warning')}} </strong> <span class="pl-2"> {{$t('database.pastver')}}</span>
          </v-alert>
        </div>
      </template>

      <!--alert for non-existing legis-->
      <v-alert 
        v-else-if="!overlay"
        dense text
        type="error"
        class="mt-0 mb-4 d-print-none"
        icon="mdi-alert-outline"
        > 
          {{$t('error.legis_unavailable')}}
      </v-alert>

      <!--TOC loading overlay-->
      <v-skeleton-loader
        v-show="overlay"
        class="mt-0 pt-0 d-print-none"
        max-width="850"
        :type="isFull?'divider, sentences, list-item-two-line, divider, heading, paragraph, list-item-three-line':'table-cell@6'"
      ></v-skeleton-loader>
            
      <!--TOC LIST-->
      <!-- Refer to capsection model for extensive section types-->
      <div class="sectiontoc mt-7 mb-10" v-if="!overlay && sections && !isFull">
        
        <div v-if="$vuetify.breakpoint.xsOnly">
          <h2 class="text-h2 mb-3 liiblack--text"> {{$t('database.toc')}}</h2>
        <!--Show as list for small mobile-->
        <template v-for="section in sections">

          <ul :key="section.id" class="pl-0" :class="{'blank': section.section_type==='BLANK'}">
            
            <li v-if="section.section_type==='BLANK'">
              <!-- <span v-html="section.title"></span> -->
              <!-- seems too much space for mobile -->
            </li>

            <li v-else-if="['LT', 'E', 'PRE'].includes(section.section_type)" class="mt-5 mobilelist parttitle" >
              <router-link :to="section.path">{{section.prov_num}} {{section.title}}</router-link>
            </li>

            <li v-else-if="['S','SCH','N','A'].includes(section.section_type)" class="mt-2 ml-9 mobilelist" style="text-indent:-10px;" >
              <router-link :to="section.path"><span class="provnum mr-2" >{{section.prov_num}}</span>{{section.title}}</router-link>
            </li>


            <li v-else class="parttitle mobilelist" :class="section.section_type=='P'? 'mt-5 ml-2 ':'mt-4 ml-4'" >
              <router-link :to="section.path"><span class="provnum">{{section.prov_num}}</span> {{section.title}}</router-link>
            </li>
              
          </ul>
        </template>
        </div>
              
        <!--Show as table for bigger surfaces-->
        <div v-if="$vuetify.breakpoint.smAndUp">
          
          <h2 v-if="legis_exists" class="text-h2 mb-3 liiblack--text"> {{$t('database.toc')}}
            <span class="d-none d-print-inline print-version"> ({{$t('database.version')}}: {{cur_ver ? display_date(cur_ver.date) : ''}})</span>
          </h2>

          <table cellspacing="0" cellpadding="0" class="sectiontoc" >
            <tbody>
              <template v-for="section in sections">
                <tr :key="section.id" :class="{'blank': section.section_type==='BLANK'}" >
                  <td nowrap="nowrap" class="toctdwidth provnum" :class="displayclass_l_num(section.section_type)">
                    <router-link :to="section.path" v-html="section.prov_num"></router-link>
                  </td>

                  <td class="pl-5"  :class="displayclass_l_title(section.section_type) + ' toctitle '" style="min-width:400px;">
                    <router-link :to="section.path" v-html="section.title"></router-link>
                  </td>

                </tr>
              </template>
            </tbody>
          </table>
        </div>

      </div>

      <!--Show all in one page-->
      <div class="case-content" v-if="!overlay && isFull">
        <h2 v-if="legis_exists" class="text-h2 mt-7 mb-1 liiblack--text"> {{$t('database.fullsection')}} 
          <span class="d-none d-print-inline print-version"> ({{$t('database.version')}}: {{cur_ver ? display_date(cur_ver.date) : ''}})</span>
        </h2>
        <div v-for="(section, index) in sections" v-bind:key="index" class="mt-2">
          <template v-if="section.section_type!=='BLANK'">
            
            <div width="100%" class="fullsechead mt-10 mb-3" :id="section.prov_num" >
              <h6 class="text-h6 pt-1">
                <router-link :to="section.path">{{section.prov_num || section.title}}
                  <v-icon x-small color="link" class="pb-1 d-print-none">mdi-link-variant</v-icon>
                </router-link>
                
              </h6>
            </div>

            <div 
              v-html="section.content" 
              class="pl-md-2 pr-md-2" :class="lang=='en'?'':'chi-case-content'"
              @click="content_clicked"
            ></div>
          </template>
        </div>
      </div>

    </template>
    
    <template v-slot:rightPanel>

      <!--Noteup-->
      <v-card id="refcard" v-if="legis_exists" flat class="rsidecard mb-4 mr-3 pb-1" max-width="400" min-width="100"  width="100%" > 
          
        <v-card-title class="mb-1">
          <h5 class="wdgt-title"> {{$t('database.wdg_ref_l')}} </h5>
        </v-card-title>

        <v-card-text class="pb-2">
          <v-tooltip bottom color="liiblack lighten-1">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn 
                  dense small block elevation="0"
                  color="primary white--text" 
                  :to="noteup_route"
                >
                  Noteup
                </v-btn>
        
              </div>
            </template>
            <span>{{$t('database.wdg_ref_noteup_legis')}}</span>
          </v-tooltip>
        </v-card-text>
      </v-card>

      <!--E legis Card-->
      <v-card id="elegiscard" v-if="legis_exists" flat class="rsidecard mb-4 mr-3 pb-1" max-width="400" min-width="100" width="100%" > 
          
        <v-card-title class="mb-1">
          <h5 class="wdgt-title"> {{$t('database.wdg_goto')}} </h5>
        </v-card-title>

        <v-card-text class="pb-2">
          <v-tooltip bottom color="liiblack lighten-1">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn 
                  dense small outlined block
                  color="navlink" 
                  target="_blank"
                  :href="elegislink"
                  >
                  {{$t('database.wdg_goto_elegis')}}
                </v-btn>
              </div>
            </template>
            <span>{{$t('database.wdg_goto_elegis_tooltip')}}</span>
          </v-tooltip>
        </v-card-text>

      </v-card>

      <!--Related Cap Card-->
      <v-card id="relcard" max-width="400" min-width="100" width="100%" class="rsidecard mb-4 mr-3 pb-1" 
        v-if="$route.params.abbr!=='instrument' && legis_exists"
        flat 
      > 
          
        <v-card-title class="mb-1">
          <h5 v-if="$route.params.abbr=='reg'" class="wdgt-title"> {{ $t('database.wdg_relatedcap') }}{{$t('labels.ordinances') }} </h5>
          <h5 v-if="$route.params.abbr=='ord'" class="wdgt-title"> {{ $t('database.wdg_relatedcap') }}{{$t('labels.regulations') }} </h5>
        </v-card-title>

        <v-card-text class="pb-2">
          <v-dialog v-if="relatedlinks" v-model="dialog"  max-width="700px"  >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dense small outlined block
                color="navlink" 
                v-bind="attrs"
                v-on="on"
              >
                {{ $t('btntxt.show') }}
              </v-btn>
            </template>
                
            <!--displayed dialogue-->
            <v-card class="pt-2 pb-5 pr-5 popup" min-height="260px">
              <v-card-title>
                <h4 v-if="$route.params.abbr=='reg'" class="text-h4 text-liiblack">{{capnum}} {{ $t('database.wdg_relatedcap') }}{{$t('labels.ordinances') }}</h4>
                <h4 v-if="$route.params.abbr=='ord'" class="text-h4 text-liiblack">{{capnum}} {{ $t('database.wdg_relatedcap') }}{{$t('labels.regulations') }}</h4>
              </v-card-title>

              <v-card-text v-if="(relatedlinks.length>0)&&($vuetify.breakpoint.xsOnly)" class="relatedtoc">
                <ul class="pl-3">
                  <li v-for="link in relatedlinks" v-bind:key="link.num" class="pb-3" >
                    <router-link :to="link.path" replace @click.native="dialog=false" class="mobilelist">
                      <strong class="provnum">CAP {{link.num}}</strong> {{link.title}}
                    </router-link>
                  </li>
                </ul>
              </v-card-text>

              <!--Show as table for bigger surfaces-->
              <v-card-text v-else-if="(relatedlinks.length>0)&&($vuetify.breakpoint.smAndUp)" class="relatedtoc">
                <table cellspacing="0" cellpadding="0" class="ml-5" >
                  <tbody>
                    <tr><td colspan="2"></td></tr> <!--empty row for border only-->
                    <tr v-for="link in relatedlinks" v-bind:key="link.num">
                      <td nowrap="nowrap" class="provnum py-2 pl-1">
                        <router-link :to="link.path" replace @click.native="dialog=false">
                          <strong> CAP {{link.num}}</strong>
                        </router-link>
                      </td>

                      <td class="pl-3 py-2" style="min-width:400px;">
                        <router-link :to="link.path" replace @click.native="dialog=false">{{link.title}}</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-card-text>

              <v-card-text v-else>
                <v-alert 
                  dense 
                  class="text-body-1 ml-0 mt-2 mb-12 rsidebg"
                  icon="mdi-alert-circle-outline"
                >
                  {{$t('database.wdg_relatedcap_nil')}}
                </v-alert>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-btn 
                    class="mt-10 navlink--text"
                    text
                    @click="dialog = false"
                  >
                    <v-icon class="mr-3">mdi-close</v-icon>
                    {{$t('btntxt.close')}}
                  </v-btn>
                </v-row>
              </v-card-text>

            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import InfoTable from '../components/InfoTable'
  import LangOpts from '../components/LangOpts'
  import DownloadWidget from '../components/DownloadWidget'
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  import scrollhelper from '@/scripts/scrollhelper'
  export default {
    name: 'SectionToc',
    data(){
      return {
        overlay: true,
        legis_exists: false,
        db_name: null,
        num: '',
        num_int: '',
        versions: [],
        cur_ver: null,  // current version
        vid:null,
        sections: [],
        relatedlinks: [],
        abbr: '',
        dialog:false,
      }
    },
    components:{
      ThreeColumn,
      InfoTable,
      LangOpts,
      DownloadWidget
    },
    watch: {
      '$i18n.locale': {
        handler: function(){
          this.versions = this.versions.map((i, index) => {
            i['datestr'] = datehelper.format_ver_time(i['date'])
            if (index === 0){
              i['datestr'] = `${i['datestr']} (${this.$t('database.wdg_legis_latest')})`
            }
            return i
          })
        },
        deep: true
      },
      '$route.path': function(newPath, oldPath){
        var newParams = this.$router.match(newPath).params
        var oldParams = this.$router.match(oldPath).params
        if (newParams.lang != oldParams.lang || newParams.cap != oldParams.cap){
          this.get_cap()
        }
      },
      /*windowTitle: function(nv){
        window.document.title = nv
      }*/
    },
    computed:{
      lang(){
        return this.$route.params.lang
      },
      isFull(){
        return this.$route.path.endsWith('/full/')|| this.$route.path.endsWith('/full')
      },
      navToggle(){
        if(this.isFull){return {
          pageName: 'sectiontoc',
          btnText: this.$t('database.toc'),
          btnIcon: 'mdi-format-list-bulleted'
        }}
        return {
          pageName: 'cap',
          btnText: this.$t('btntxt.checkcontent'),
          btnIcon: 'mdi-text-long'
        }
      },
      capnum(){
        return this.num ? (this.$route.params.abbr=='instrument' ? 'Instrument ' : 'CAP ') + this.num : null
      },
      /*windowTitle(){
        return this.capnum + ' ' + (this.cur_ver ? this.cur_ver.title : '')
      },*/
      paths(){
        if (this.legis_exists){
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
            {text: this.db_name, disabled: false, href: {name: 'legis-db', params: this.$route.params}},
            {text: this.capnum, disabled: true}
          ]
        } else {
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
          ]
        }
      },
      infoTableContent(){
        var lastest_ver_date = this.versions.length > 0 ? datehelper.format_ver_time(this.versions[0]['date']) : ''
        return [
          {name: this.$t('database.capno'), value: this.capnum},
          // {name: this.$t('database.wdg_status'), value: 'Not yet in operation*'},
          {name: this.$t('database.wdg_legis_latest'), value: lastest_ver_date},
          // {name: this.$t('database.wdg_legis_enact'), value: 'DD-MM-YYYY*'},
          {name: this.$t('database.wdg_legis_vercount'), value: this.versions.length}
        ]
      },
      is_latest(){
        return this.versions.map(ver => ver['id']).indexOf(this.vid) <= 0
      },
      noteup_route(){
        return {
          name: 'legis-noteup',
          query: {
            'lang': this.$route.params.lang,
            'cap': this.$route.params.cap,
          }
        }
      },
      elegislink(){
        if(!this.cur_ver) return 'https://www.elegislation.gov.hk'
        var link = 'https://www.elegislation.gov.hk/hk/cap' + this.num 
        link += (this.lang === 'tc'? '!zh-Hant-HK' : this.lang=='sc' ? '!sc': '') 
        link += "@" + this.cur_ver.date.substring(0, this.cur_ver.date.indexOf('+')) 
        return link
      }
    },
    methods:{
      display_date: datehelper.display_date,
      content_clicked: scrollhelper.content_clicked,
      store_local(){
        sessionStorage.setItem(this.num + '_' + this.lang, this.vid);
      },
      clear_local(){
        delete sessionStorage[this.$route.params.cap + '_' + this.lang]
      },
      fetch_local(){
        if (this.$route.params.cap + '_' + this.lang in sessionStorage){
          return parseInt(sessionStorage[this.$route.params.cap + '_' + this.lang])
        } else {
          return null
        }
      },
      async change_ver(event){
        this.overlay = true
        try {
          await this.get_capversiontoc()
          this.cur_ver = this.versions.find(ver => {return ver.id === this.vid})
        } catch(err) {
          console.error(err)
          this.legis_exists = false
        } finally {
          this.overlay = false
          this.store_local()
        }
      },
      go_trans(lang){
        var params = {...this.$route.params, 'lang': lang}
        this.$router.push({name: this.$route.name, params: params})
      },
      async get_cap(){
        this.overlay = true
        const params = this.$route.params
        var ls_vid = this.fetch_local()
        if(ls_vid){
          this.vid = parseInt(ls_vid)
        } else {
          this.vid = null
          this.sections = []
          this.clear_local()
        }
        try {
          const res = await api.get_cap(this.lang, params.cap, params.abbr)
          this.num = res['num']
          this.num_int = res['num_int']
          this.db_name = res['db']
          this.abbr = res['cap_type']

          if (this.abbr == 'ord'){
            this.get_related_caps('reg')
          }
          if (this.abbr == 'reg'){
            this.get_related_caps('ord')
          }

          await this.get_capversions()
          await this.get_capversiontoc()

          /*window.document.title = this.windowTitle*/
          this.store_local()
          this.legis_exists = true

          await this.$nextTick()
          scrollhelper.scroll_to_anchor(this.$route.hash)

        } catch(err){
          console.error(err)
          this.legis_exists = false
        } finally {
          this.overlay = false
        }
      },
      async get_related_caps(abbr){
        this.relatedlinks = await api.get_related_caps(this.num_int, this.lang, abbr)
      },
      async get_capversions(){
        const res = await api.get_capversions(this.lang, this.num)
        this.versions = res.map((i, index) => {
          i['datestr'] = datehelper.format_ver_time(i['date'])
          if (index === 0){
            i['datestr'] = `${i['datestr']} (${this.$t('database.wdg_legis_latest')})`
          }
          return i
        })
        var vids = this.versions.map(ver => ver.id)
        if(this.vid == null || !vids.includes(this.vid)){
          this.vid = this.versions[0]['id']
        }
        this.cur_ver = this.versions.find(ver => {return ver.id === this.vid})
      },
      async get_capversiontoc(){
        // getting sections
        const res = await api.get_capversiontoc(this.vid)
        // Add a Title row before Schedule, Appendix, and Annex
        this.sections = []
        res.forEach((section, i) => {
          if (['P', 'SCH', 'N', 'A'].includes(section.section_type)){
            if (i > 0 && section.section_type !== res[i-1].section_type){
              this.sections.push({
                capversion: null,
                content: '',
                id: null,
                internal_order: null,
                noteup_links: null,
                path: '',
                prov_num: '',
                pub_date: null,
                section_type: 'BLANK',
                sub_path: '',
                title: '&#8203;',
              })
            }
          }
          this.sections.push(section)
        })
          
        const pos = this.versions.map(function (i) {
          return i['id']
        }).indexOf(this.vid)

      },
      displayclass_l_num(section_type){
        switch(section_type){
          case 'BLANK':
            return 'blank'
          case 'P': 
            return 'parttitle'
          case 'D': 
            // return 'parttitle pl-3 pt-3'
            return 'parttitle pl-3'
          case 'SD': 
            // return 'parttitle pl-6 pt-1'
            return 'parttitle pl-6'
          case 'LT':
          case 'E':
          case 'PRE': 
            // return 'parttitle py-1'
            return 'parttitle'
          default:
            return 'sectionnum'
        }
      },
      displayclass_l_title(section_type){
        switch(section_type){
          case 'BLANK':
            return 'blank'
          case 'P': 
            return 'parttitle'
          case 'D': 
            // return 'parttitle pt-3'
            return 'parttitle'
          case 'SD': 
            // return 'parttitle pt-1'
            return 'parttitle'
          case 'LT':
          case 'E': 
          case 'PRE':
            return 'parttitle px-4'
          default:
            return 'sectiontitle px-4'
        }
      }
    },
    mounted(){
      this.get_cap()
    },
    metaInfo(){
      return{
        title: this.capnum + ' ' + (this.cur_ver ? this.cur_ver.title : ''),
         meta: [
          {
            name: 'description',
            content: 'Table of contents for ' + this.capnum + ' ' + (this.cur_ver ? this.cur_ver.title : '') +". Click to read the full legislation.",
          }
        ],
      }
    },
  }
</script>

<style lang="scss" scoped>
   @import '@/sass/_typography.scss';

  .v-btn--active.no-active:not(:focus):not(:hover)::before{                                                                             
    opacity: 0 !important; /*keep nav button color*/
  }

  /*for desktop TOC*/
  .toctdwidth{
    min-width: 150px;  /*cap200 is too long, e.g "第159AAF條"*/
  }
  .toctitle{
    line-height: 1.2rem;
  }

  /*for mobile TOC*/
  ul {
    list-style-type: none;
  }

  .mobilelist{
    font-size: 11.5pt;
    line-height: 14pt !important;
  }

  .sectiontoc table{
    border: none !important;
  }

  td{
    vertical-align: baseline;
    text-align: left;
    padding-top: 1px  !important;
    padding-bottom: 1px  !important;
  }

  .sectiontoc tr:not(.blank):hover{
    background: var(--v-lsidebg-base);
    text-decoration-line: underline;
    text-decoration-color: unset;
    text-underline-offset: 2px;
  }

  .sectiontoc a {
    @include link-no-underline;
  }
  
  /*for related regulation on the right*/
  .relatedtoc {
    a {
      text-decoration-line: none !important;
    }
    li{
      text-indent: -1.5em;  /*2.3em = align to CAP */
      margin-left: 1.5em;
    }
    td {
      line-height: 14pt !important;
      border-bottom: 1px solid var(--v-darkgrey-lighten4) !important;
    }
    a:hover, tr:hover {
      background-color: var(--v-lsidebg-base);
    } 
  }

  /*general formatting for TOC*/
  .provnum{
    color: var(--v-liiblack-base)!important;
  }

  .provnum a{
    color: var(--v-liiblack-base)!important;
  }

  .parttitle{
    color: var(--v-link-base) !important;
    font-weight: 700;
  }

  .sectionnum {
    text-align: right !important;
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .sectiontitle a{
    @include link-no-underline;
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .tab {
    display: inline-block;
    margin-left: 10px;
  }

  .titlecapno{
    color: var(--v-footergrey-darken2);
    font-size: 12pt !important;
    font-weight: 700;
    display: inline-block;
    vertical-align: top;
    @media print{
      vertical-align: baseline;
      font-size:11pt;
    }
  }
  .print-version{ /*for version date - print only*/
    display: block;
    margin-left: 1em;
    font-size:11pt;
  }

  .case-content a{
    color: var(--v-link-base);
  }

  /*show all contents*/
  .fullsechead{
    text-align: end;
    border-top:1px solid var(--v-darkgrey-lighten3);
    @media print{
      font-size: 9pt;
    }

  }

  /*for printing, changes body text only, */
  .case-content, .sectiontoc{
    @media print{
      font-size: 9.5pt;
    }
  }
  #maincon{
    @media print{
      width:100%;
    }
  }

  @import '@/sass/_legis.scss';
</style>